module.exports = __webpack_public_path__ + "static/media/slider-link-gris.bd74abaa.svg";